var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.94%",
    y1: "20.59%",
    x2: "63.311%",
    y2: "82.457%",
    id: "7p0x43y2ca"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A",
    offset: ".8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE3D4A",
    offset: "44.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52030",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "40.022%",
    y1: "35.052%",
    x2: "84.692%",
    y2: "101.977%",
    id: "eau0cjfcbb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE9F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EA7B0",
    offset: "99.8%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "29.02%",
    y1: "38.326%",
    x2: "82.263%",
    y2: "67.952%",
    id: "xegg7psp6c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D61A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16528C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C11.526 0 7.486 1.84 4.583 4.8h22.835A15.948 15.948 0 0 0 16 0zm11.417 27.2H4.583A15.944 15.944 0 0 0 16 32c4.474 0 8.514-1.84 11.417-4.8z",
    fill: "url(#7p0x43y2ca)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.973 21.6H1.027a15.992 15.992 0 0 0 3.555 5.6h22.835a15.994 15.994 0 0 0 3.556-5.6zM27.417 4.8H4.583a15.992 15.992 0 0 0-3.555 5.6h29.945a15.994 15.994 0 0 0-3.556-5.6z",
    fill: "url(#eau0cjfcbb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16a15.94 15.94 0 0 0-1.027-5.6H1.027A15.94 15.94 0 0 0 0 16c0 1.974.374 3.854 1.027 5.6h29.945A15.922 15.922 0 0 0 32 16z",
    fill: "url(#xegg7psp6c)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTh);
export default __webpack_public_path__ + "static/media/th.5f2d7930347bd0bc4abc5c68544daf23.svg";
export { ForwardRef as ReactComponent };